import {useEffect,useState } from 'react'
import { getFacturas, getFacturasGlobal } from '../requests/request'
import axios from 'axios'
import { useAppSelector  } from "../../../../../../redux/hooks"
import { useAuth } from '../../../../auth'

const API_URL = process.env.REACT_APP_API_URL




export default function GetFacturasEmitidas(props:any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const tenant= useAppSelector(state =>state.TenantSlice.id)
  const{currentUser}= useAuth()

    const [Facturas,setFacturas]= useState([
       { mes:'',
         pdf:'',
         xml:''}
    ])


  useEffect( () => {

      if(Id !== 0 && tenant===0  && currentUser?.ListPermiso?.includes('Accounts.Billing')){
        getFacturas(Id).then(response=>{
            setFacturas(response.data)
        })

      }
      else if(Id !== 0 && tenant!==0 && currentUser?.ListPermiso?.includes('Accounts.Billing') ){
        getFacturasGlobal(Id,tenant).then(response=>{
            setFacturas(response.data)
        })

      }

 }, [Id]
 )
    
    if (Id !== 0 ){

    return(
        <div style={{ marginLeft: '15px'}} className="card card-custom flex-column-fluid">
                <div className="card-header bg-marino flex-center">
                    <h4 className="f-titulo-cards fs-p  text-w ">BILLS</h4>
                </div>
                <div className="card-body  ">
                <table className="w-full f-parrafo  caption-bottom  custom-table">
                  <thead className='flex-center'>
                      <tr className="fw-bolder fs-6 text-marino ">
                          <th className="table-cell">MONTH</th>
                          <th className="table-cell">BILL</th>
                      </tr>
                  </thead>
                  <tbody className='flex-center'>
                    { Facturas?.map((d,i)=>(
                        <tr key={i} className='table-row'>
                          <td className="table-cell">{d.mes}</td>
                          <td className="table-cell"> <button onClick={()=> axios({
                                url: API_URL +'/v1/suscription/'+Id+'/Billing/'+d.xml, //your url
                                method: 'GET',
                                responseType: 'blob', // important
                            }).then((response) => {
                                // create file link in browser's memory
                                const href = URL.createObjectURL(response.data);
                            
                                // create "a" HTML element with href to file & click
                                const link = document.createElement('a');
                                link.href = href;
                                link.setAttribute('download', d.xml.split(".")[0]+'.xml'); //or any other extension
                                document.body.appendChild(link);
                                link.click();
                            
                                // clean up "a" element & remove ObjectURL
                                document.body.removeChild(link);
                                URL.revokeObjectURL(href);
                            })} type="button" className="btn btn-light bi bi-filetype-xml btn-active-color-success"></button>
                          
                          <button onClick={()=>
                            axios({
                                url: API_URL +'/v1/suscription/'+Id+'/Billing/'+d.pdf, //your url
                                method: 'GET',
                                responseType: 'blob', // important
                            }).then((response) => {
                                // create file link in browser's memory
                                const href = URL.createObjectURL(response.data);
                            
                                // create "a" HTML element with href to file & click
                                const link = document.createElement('a');
                                link.href = href;
                                link.setAttribute('download', d.pdf.split(".")[0]+'.pdf'); //or any other extension
                                document.body.appendChild(link);
                                link.click();
                            
                                // clean up "a" element & remove ObjectURL
                                document.body.removeChild(link);
                                URL.revokeObjectURL(href);
                            })
                          
                          } type="button" className="btn btn-light bi bi-file-earmark-pdf btn-active-color-success"></button>
                          </td>
                        </tr>
                    ))}

                  </tbody>
                </table>
            </div>
      </div>
    )
  
}

else{
  return(
    <div style={{ marginLeft: '15px'}} className="card card-custom flex-column-fluid">
            <div className="card-header bg-marino  flex-center">
                <h4 className="f-titulo-cards fs-md  text-w ">BILLS</h4>
            </div>
            <div className="card-body  ">
            <table className="table table-row-dashed table-row-gray-300 gy-2">
              
              <tbody className='flex-center'>
                    <div className="text-center f-parrafo">
                      Select a Cloud with available subscriptions
                    </div>
              </tbody>
            </table>
        </div>
  </div>
)

}}